import{gql as r}from"@apollo/client";const o=r`
  query searchGroups($projectId: String!) {
    group {
      searchGroups(projectId: $projectId) {
        id
        name
        unit {
          id
          name
          groupId
        }
      }
    }
  }
`;export{o as SEARCH_GROUPS_QUERY};
//# sourceMappingURL=useSearchGroups.graphql.js.map
